// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__2YSoe","form":"EditListingDescriptionPanel_form__2ehq0","title":"EditListingDescriptionPanel_title__3alVo"};